import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setCustomerTraitsSearchTerm } from 'actions'
import { getCustomerRequestByWorkspaceSlug, getMatchingTraits } from 'selectors'
import CustomersProfileTraits from '../components/Customers/CustomersProfileTraits'

class CustomersProfileAppTraits extends Component {
  render () {
    return React.createElement(CustomersProfileTraits, this.props)
  }
}

function mapStateToProps (state, ownProps) {
  const { workspaceSlug } = ownProps.params

  const { isRequesting, didRequestFail } = getCustomerRequestByWorkspaceSlug(state, workspaceSlug)
  const traits = getMatchingTraits(state, workspaceSlug)

  return {
    traits,
    workspaceSlug,
    didRequestFail,
    isRequesting
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    onSearch: str => dispatch(setCustomerTraitsSearchTerm(str))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomersProfileAppTraits)



// WEBPACK FOOTER //
// ./containers/CustomersProfileAppTraits.js